// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__GkIWS","active":"SwitchDate_active__8MMf2"};